import { ApprovalFlowListPage, ApprovalFlowEditPage, ApprovalFlowCreatePage } from './imports';

export const purchaseOrderRoutes = [
  {
    path: 'purchase-orders',
    children: [
      { element: <ApprovalFlowListPage />, index: true },
      { path: 'list', element: <ApprovalFlowListPage /> },
      { path: ':id/edit', element: <ApprovalFlowEditPage /> },
      { path: 'new', element: <ApprovalFlowCreatePage /> },
    ],
  },
];
